import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';

export const invalidStateStyle = {
	borderColor: token('color.border.danger', colors.R400),
} as const;
